import React from "react";
import { compose } from "redux";
import withTranslations from "../../../../../../../hocs/withTranslations";
import withNewNotifications from "../../../../../../../hocs/withNewNotifications";
import Checkbox from "../../../../../../../lib/Checkbox/Checkbox";
import Radio from "../radio/Radio";
import SearchInput from "./SearchInput";

import "./Filters.scss";

const Filters = ({
  translate,
  filters,
  setFilter,
  setAllFilters,
  notificationTypesFilters
}) => {
  const checkboxCount = Object.values(filters).filter(
    f => f.type === "checkbox"
  ).length;

  const checkedCheckboxCount = Object.values(filters).filter(
    f => f.type === "checkbox" && f.value
  ).length;

  const selectAllValue = checkedCheckboxCount > 0;
  const showOnlyUnread = filters.showOnlyUnread.value;

  return (
    <>
      <SearchInput />
      <label className={"text-xs font-medium text-black-7 mb-3 block"}>
        {translate("Show notifications:")}
      </label>
      <div className={"flex flex-col gap-1.5 mb-4"}>
        <Radio
          id={"read"}
          name={"read"}
          label={translate("All")}
          checked={showOnlyUnread === false}
          onChange={() => {
            setFilter("showOnlyUnread", false);
          }}
        />
        <Radio
          id={"unread"}
          name={"read"}
          label={translate("Unread")}
          checked={showOnlyUnread === true}
          onChange={() => {
            setFilter("showOnlyUnread", true);
          }}
        />
      </div>
      <div className={"subcategories bg-gray-4.70 p-2"}>
        <label className={"text-xs font-medium text-black-7 mb-3 block"}>
          {translate("Subcategories")}
        </label>
        <div className={"flex flex-col gap-1.5"}>
          <Checkbox
            label={translate("Select / Unselect all")}
            checked={selectAllValue}
            indeterminate={checkboxCount > checkedCheckboxCount}
            onClick={() => {
              const filtersToChange = [];

              for (const [name, filter] of Object.entries(filters)) {
                if (filter.type !== "checkbox") {
                  continue;
                }

                filtersToChange.push(name);
              }

              setAllFilters(filtersToChange, !selectAllValue);
            }}
          />
          <hr className={"hr-horizontal-1 m-0"} />
          {Object.entries(notificationTypesFilters).map(([name, { value }]) => {
            return (
              <Checkbox
                key={name}
                label={translate(`filter_${name}`)}
                checked={value}
                name={name}
                onClick={() => {
                  setFilter(name, !value);
                }}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default compose(withTranslations, withNewNotifications)(Filters);
